<script setup>
const activeKey = ref('1')
console.log(activeKey.value)
</script>

<template>
    <div>
        <div>
            <company-header :id="activeKey"></company-header>
            <div class="tabs2">
                <a-tabs v-model:activeKey="activeKey" animated>
                    <!-- // 方德证券 -->
                    <a-tab-pane key="1" :tab="$t('fdzq')" >
                        <security></security>
                    </a-tab-pane>
                    <a-tab-pane key="2"  :tab="$t('fdgmg')" >
                        <hkusa-stock></hkusa-stock>
                    </a-tab-pane>
                    <a-tab-pane key="3" :tab="$t('fdlc')" >
                        <course></course>
                    </a-tab-pane>
                    <a-tab-pane key="4"  :tab="$t('jgzz')" >
                        <supervise></supervise>
                    </a-tab-pane>
                    <a-tab-pane key="5"  :tab="$t('hzhb')" >
                        <cooperation></cooperation>
                    </a-tab-pane>
                    <a-tab-pane key="6" :tab="$t('zlhb')" >
                        <strategy></strategy>
                    </a-tab-pane>
                    <a-tab-pane key="7"  :tab="$t('fdgg')" >
                        <announcement></announcement>
                    </a-tab-pane>
                    <a-tab-pane key="8"  :tab="$t('jrwm')" >
                        <joinus></joinus>
                    </a-tab-pane>
                    <a-tab-pane key="9"  :tab="$t('lxwm')" >
                        <connection></connection>
                    </a-tab-pane>
                    <a-tab-pane key="10"  :tab="$t('yykh')" >
                        <open-account></open-account>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>
